export default __webpack_public_path__ + "static/media/QCam-Icon-1.451198bf.svg";